export const DAY_MS = 86_400_000;

export const ALL_DAYS_MIN_DAY_PX = 44;

export const COMPACT_MIN_DAY_PX = 30;

export const LETTERS_MIN_DAY_PX = 14;

export const WEEK_TEXT_MIN_PX = 98;

export const WEEK_TEXT_CHAR_PX = 6.5;

// Thinned day labels: every Nth day is labelled, N the first stride giving this much room.
export const THINNED_DAY_LABEL_MIN_PX = 18;

export const THINNED_DAY_LABEL_STRIDES: ReadonlyArray<number> = [2, 3, 7, 14];

// The compact row labels every day when there is room.
export const COMPACT_DAY_LABEL_STRIDES: ReadonlyArray<number> = [
  1,
  ...THINNED_DAY_LABEL_STRIDES,
];

export const COMPACT_DAY_ROW_HEIGHT_PX = 16;

export const SUNDAY = 0;

export const MONDAY = 1;

export const SATURDAY = 6;

export const DAYS_PER_WEEK = 7;

export const WEEK_BAND_HEIGHT_PX = 18;

export const DAY_ROW_HEIGHT_PX = 40;

export const EDGE_PIXEL_TOLERANCE = 0.5;

export const MAX_AXIS_DAYS = 400;

export const WEEK_STRIDE_EPOCH_MS = Date.UTC(2024, 0, 1);

export const WEEK_CELL_CLASS = 'week-cell';

export const WEEK_BAND_CLASS = 'week-band';

export const DAY_ROW_CLASS = 'day-row';

export const WEEKEND_CLASS = 'weekend';

export const WEEKDAY_CLASS = 'weekday';
